//TODO: Replace Document Viewer With PDF Viewer and Serve PDF Only For Preview
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import Sam_CV from './Sam_CV.pdf';
import styles from './DocumentViewer.module.css';

function DocumentViewer() {
  //TODO: Replace Document Viewer With PDF Viewer and Serve PDF Only For Preview
  const docs = [
    { uri: Sam_CV }, // Local File
  ];

  return (
    <div style={{ height: '100%', overflow: 'hidden' }}>
      <div style={{ maxHeight: '40rem', overflow: 'auto' }}>
        <DocViewer
          className={styles.docViewer}
          config={{ header: { disableHeader: true } }}
          pluginRenderers={DocViewerRenderers}
          documents={docs}
        />
      </div>
    </div>
  );
}

export default DocumentViewer;
